import React, { useEffect, useState } from "react";
import Button from "./ds/Button";
import Icon from "./ds/Icon";
import Message from "./ds/Message";
import Modal from "./ds/Modal";
import Options from "./ds/Options";
import Overlay from "./ds/Overlay";
import Select from "./ds/Select";
import Tag from "./ds/Tag";
import Textfield from "./ds/Textfield";
import MediaSelection from "./MediaSelection";

export default function RowUser({
  user,
  loading,
  onChangeName,
  onChangeEmail,
  onChangeRole,
  onChangePassword,
  onChangeMedias,
  onDelete,
}) {
  const [options, setOptions] = useState(false);
  const [editName, setEditName] = useState(false);
  const [editEmail, setEditEmail] = useState(false);
  const [editRole, setEditRole] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [editMedias, setEditMedias] = useState(false);
  const [remove, setRemove] = useState(false);
  const [name, setName] = useState(user.name);
  const [lastName, setLastName] = useState(user.last_name);
  const [email, setEmail] = useState(user.email);
  const [role, setRole] = useState(user.role);
  const [password, setPassword] = useState('');
  const [medias, setMedias] = useState(user.medias.map((m) => m.id));

  // Options
  useEffect(() => {
    document.body.addEventListener('click', () => setOptions(false));
  }, []);

  function showOptions() {
    setTimeout(() => {
      setOptions(true);
    }, 1);
  }

  return (
    <>
      <div className="row">
        <div className="col-3">
          <p style={{
            lineHeight: '18px',
            color: user.deleted_at ? '#c33' : '#000',
          }}>
            {user.name} {user.last_name} <br/>
            <span style={{ color: '#999', fontSize: '13px' }}>{user.username}</span>
          </p>
        </div>

        <div className="col-5">
          <p>{user.email}</p>
        </div>

        <div className="col-2">
          <Tag type="secondary" label={user.role} />
        </div>

        <div className="col-2">
          <div className="options">
            <button onClick={showOptions}>
              <Icon icon="options" />
            </button>

            {options && (
              <div>
                <Options>
                  <li onClick={() => setEditName(true)}><Icon icon="pencil" />Nombre</li>
                  <li onClick={() => setEditEmail(true)}><Icon icon="pencil" />Email</li>
                  <li onClick={() => setEditRole(true)}><Icon icon="pencil" />Rol</li>
                  <li onClick={() => setEditPassword(true)}><Icon icon="pencil" />Contraseña</li>
                  <li onClick={() => setEditMedias(true)}><Icon icon="burger-menu" />Medios</li>
                  <li onClick={() => setRemove(true)}><Icon icon="trash" />Eliminar</li>
                </Options>
              </div>
            )}
          </div>
        </div>
      </div>

      {editName && (
        <Overlay>
          <Modal title="Editar nombre" onclose={() => setEditName(false)}>
            <div id="edit-user">
              <div className="fields">
                <div className="name">
                  <Textfield
                    value={name}
                    onChange={e => setName(e.target.value)}
                  />
                  <Textfield
                    value={lastName}
                    onChange={e => setLastName(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <Button
              label="Actualizar"
              loading={loading}
              onclick={async () => {
                await onChangeName(user.id, {
                  name,
                  lastName,
                });
                setEditName(false);
              }}
            />
          </Modal>
        </Overlay>
      )}

      {editEmail && (
        <Overlay>
          <Modal title="Editar email" onclose={() => setEditEmail(false)}>
            <div id="edit-user">
              <div className="fields">
                <div>
                  <Textfield
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <Button
              label="Actualizar"
              loading={loading}
              onclick={async () => {
                await onChangeEmail(user.id, email);
                setEditEmail(false);
              }}
            />
          </Modal>
        </Overlay>
      )}

      {editRole && (
        <Overlay>
          <Modal title="Cambiar rol" onclose={() => setEditRole(false)}>
            <div id="edit-user">
              <Select
                placeholder="Rol"
                value={role}
                onChange={e => setRole(e.target.value)}
              >
                <option value="user">Periodista</option>
                <option value="director">Director</option>
                <option value="admin">Administrador</option>
              </Select>
            </div>

            <Button
              label="Actualizar"
              loading={loading}
              onclick={async () => {
                await onChangeRole(user.id, role);
                setEditRole(false);
              }}
            />
          </Modal>
        </Overlay>
      )}

      {editPassword && (
        <Overlay>
          <Modal title="Cambiar contraseña" onclose={() => setEditPassword(false)}>
            <div id="edit-user">
              <div className="fields">
                <div>
                  <Textfield
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                  />
                </div>
              </div>
            </div>

            <Button
              label="Actualizar"
              loading={loading}
              onclick={async () => {
                await onChangePassword(user.id, password);
                setEditPassword(false);
              }}
            />
          </Modal>
        </Overlay>
      )}

      {editMedias && (
        <Overlay>
          <Modal title="Asignar a medios" onclose={() => setEditMedias(false)}>
            <MediaSelection
              selectedMedias={medias}
              loading={loading}
              onMediasSelected={(medias) => {
                setMedias(medias);
              }}
              onConfirm={async (medias) => {
                await onChangeMedias(user.id, medias);
                setEditMedias(false);
              }}
            />
          </Modal>
        </Overlay>
      )}

      {remove && (
        <Overlay>
          <Modal title="Eliminar usuario" onclose={() => setRemove(false)}>
            <Message type="warning" description={`Seguro que quieres eliminar al usuario "${user.name} ${user.last_name}"? Esta acción no se puede deshacer.`} />

            <Button
              type="destructive"
              label="Eliminar"
              loading={loading}
              onclick={() => onDelete(user.id)}
            />
          </Modal>
        </Overlay>
      )}
    </>
  )
}
